import { render, staticRenderFns } from "./BatteryReadingsDialog.vue?vue&type=template&id=31155a20"
import script from "./BatteryReadingsDialog.vue?vue&type=script&lang=js"
export * from "./BatteryReadingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports